import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import ProtectedButton from "../RBAC/ProtectedButton";

export default function RaiseFlagModal({ show, onClose, onSend, projectInfo }) {
    const [description, setDescription] = useState("");
    const [sending, setSending] = useState(false);

    const handleSend = async () => {
        if (!description.trim()) return;
        
        setSending(true);
        try {
            await onSend(description);
            setDescription("");
            onClose();
        } catch (error) {
            console.error("Failed to send escalation:", error);
        } finally {
            setSending(false);
        }
    };

    const handleClose = () => {
        setDescription("");
        onClose();
    };

    if (!show) return null;

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            size="lg"
            backdrop="static"
        >
            <Modal.Header closeButton style={{ borderBottom: "2px solid #f0f0f0" }}>
                <Modal.Title className="d-flex align-items-center gap-2">
                    <span style={{ fontSize: "24px" }}>🚩</span>
                    <span className="fw-bold">Raise a Flag</span>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="p-4">
                <div className="mb-4">
                    <div 
                        className="p-3 rounded-3"
                        style={{
                            background: "#FFF4E6",
                            border: "1px solid #FFD666"
                        }}
                    >
                        <p className="mb-2 fw-semibold" style={{ color: "#D46B08" }}>
                            📋 Project Information
                        </p>
                        <div className="small text-dark">
                            <div><strong>Project ID:</strong> {projectInfo?.projectId}</div>
                            <div><strong>Project Name:</strong> {projectInfo?.projectName}</div>
                            <div><strong>Your Name:</strong> {projectInfo?.pmName}</div>
                        </div>
                    </div>
                </div>

                <Form.Group>
                    <Form.Label className="fw-semibold mb-2">
                        Describe the Issue <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={6}
                        placeholder="Please describe the issue, concern, or escalation you need admin support with..."
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        style={{
                            resize: "none",
                            borderRadius: "8px",
                            padding: "12px",
                        }}
                    />
                    <Form.Text className="text-muted">
                        This will be sent to the admin team at admin@cnerzy.com
                    </Form.Text>
                </Form.Group>
            </Modal.Body>

            <Modal.Footer style={{ borderTop: "2px solid #f0f0f0" }}>
                <ProtectedButton
                    permission="raiseFlag"
                    variant="outline-secondary"
                    onClick={handleClose}
                    disabled={sending}
                    style={{
                        minWidth: "100px",
                        borderRadius: "8px",
                        padding: "10px 20px"
                    }}
                >
                    Cancel
                </ProtectedButton>
                <ProtectedButton
                    permission="raiseFlag"
                    onClick={handleSend}
                    disabled={!description.trim() || sending}
                    style={{
                        backgroundColor: "#DC2626",
                        border: "none",
                        minWidth: "100px",
                        borderRadius: "8px",
                        padding: "10px 20px"
                    }}
                >
                    {sending ? "Sending..." : "Send to Admin"}
                </ProtectedButton>
            </Modal.Footer>
        </Modal>
    );
}